import {FC} from 'react';
import {styled, SxProps, Typography} from '@mui/material';
import {Variant} from '@mui/material/styles/createTypography';

import {statusColors} from '../../shared/colors';
import {statusCodeTranslation} from '../../shared/status.data';
import {get} from 'lodash';
import {Theme} from '@mui/system';
import {StatusCode} from '../../shared/types/statusCode';

interface IStatus {
  entity: keyof typeof statusCodeTranslation;
  code?: StatusCode;
  variant?: Variant;
  border?: boolean;
  sx?: SxProps<Theme>;
}

interface StatusContainerProps {
  background?: string;
  borderColor?: string;
  border?: boolean;
}

const StatusContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'background' && prop !== 'borderColor' && prop !== 'border',
})<StatusContainerProps>(({background, borderColor, border}) => ({
  padding: '0 16px',
  borderRadius: '5px',
  width: 'fit-content',
  display: 'inline-block',
  backgroundColor: background,
  border: border ? `1px solid ${borderColor}` : 0,
}));

const Status: FC<IStatus> = ({entity, code, variant = 'subtitle1', border, sx}) => {
  if (!code) return null;

  const translations = statusCodeTranslation[entity];
  const color = statusColors[code];

  return (
    <StatusContainer background={color?.background} borderColor={color?.border} border={border}>
      <Typography variant={variant} color={color?.text} sx={sx}>
        {get(translations, code, code)}
      </Typography>
    </StatusContainer>
  );
};

export default Status;
